import { SxProps, Theme } from '@mui/material';

import { spacing } from '~theme/AppTheme';

export type InvoicesTableColumnKey =
  | 'checkbox'
  | 'driver_and_vendor'
  | 'truck'
  | 'truck_type'
  | 'driver_start'
  | 'driver_stop'
  | 'totals_hours'
  | 'loads_completed'
  | 'ticket_quantity'
  | 'total'
  | 'actions';

type InvoicesTableColumn = {
  key: InvoicesTableColumnKey;
  size: string;
  sx?: SxProps<Theme>;
  title?: string;
};

export const columns: InvoicesTableColumn[] = [
  {
    key: 'checkbox',
    size: `calc(20px + ${spacing(2)})`,
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'driver_and_vendor',
    title: 'Driver & Vendor',
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'truck',
    title: 'Truck',
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'truck_type',
    title: 'Truck Type',
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'driver_start',
    title: 'Driver Start',
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'driver_stop',
    title: 'Driver Stop',
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'totals_hours',
    title: 'Totals Hours',
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'loads_completed',
    title: 'Loads Completed',
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'ticket_quantity',
    title: 'Ticket Qty',
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'total',
    title: 'Total',
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'actions',
    title: 'Invoice Status',
    size: `calc(150px + ${spacing(2)})`,
    sx: { p: 1, overflow: 'hidden', textAlign: 'right' },
  },
];

export const gridTemplateColumns = columns.map((column) => column.size).join(' ');
